export default "__VITE_ASSET__CTFmCvbq__"